import React, { useState, useEffect, useCallback } from 'react';
import CheerioButton from '../../../Components/CheerioButton';
import colors from '../../../Utils/colors';
import { useSelector, useDispatch } from 'react-redux';
import { editCustomDomainAPI, createCustomDomainAPI, verifyCustomDomainAPI, getUserApi, verifyCertificateApi } from '../../../Services';
import { toast, ToastContainer  } from 'react-toastify';
import { Tooltip } from '@mui/material';
import images from '../../../Utils/images';
import SpinnerLoader from '../../../Components/SpinnerLoader'

import "./DomainDetails.css";

export const DomainDetails = () => {
  const localdata = useSelector((state) => state.main.localdata);
  const [baseURL, setBaseURL] = useState(localdata?.domainDetails?.domain ?? "");
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [verifyDomainApiTimer, setVerifyDomainApiTimer] = useState(0);
  const [testConnectionApiTimer, setTestConnectionApiTimer] = useState(0);
  const dispatch = useDispatch();

  const isEditingBaseURL = localdata?.domainDetails?.domain ? true : false;
  const authtoken = useSelector((state) => state.main.auth_token);

  const setVerifyApiTimeOutCallback = useCallback(() => setVerifyDomainApiTimer(currTimer => currTimer - 1), []);
  const setTestConnectionApiTimeOutCallback = useCallback(() => setTestConnectionApiTimer(currTimer => currTimer - 1), []);

  useEffect(() => {
    verifyDomainApiTimer > 0 && setTimeout(setVerifyApiTimeOutCallback, 1000);
  }, [verifyDomainApiTimer, setVerifyApiTimeOutCallback]);

  useEffect(() => {
    testConnectionApiTimer > 0 && setTimeout(setTestConnectionApiTimeOutCallback, 1000);
  }, [testConnectionApiTimer, setTestConnectionApiTimeOutCallback]);

  const resetVerifyApiTimer = function () {
    if (!verifyDomainApiTimer) {
      setVerifyDomainApiTimer(60);
    }
  }
  const resetTestConnectionApiTimer = function () {
    if (!testConnectionApiTimer) {
      setTestConnectionApiTimer(60);
    }
  }
  const handleTestConnection = () => {
    setLoading(true);
    const token = authtoken;
    verifyCustomDomainAPI(token).then((res) => {
      setLoading(false);
      resetTestConnectionApiTimer();
        if (res?.flag) {
          if(res?.data){
            toast.success("Successfully Verified Domain connection");   
          }else{
            toast.error("Failed to verify custom domain connection");
          }
        }else{
            toast.error(res?.message);
        }
    }).catch((err) => {
        console.log(err?.message);
        toast.error(err?.message);
    });
  };

   const getuserapicall = () => {
          setLoading(true)
          let token = authtoken;
          getUserApi(token).then((res) => {
            setLoading(false);
              // console.log('get user api response ==> ', res);
              if (res?.flag) {
                  dispatch({ type: 'addLocaldata', payload: res?.data });     
              } else {
                  navigate('/');
                  toast.error(res?.message);
              }
          });
    };

  const handleEditBaseURL = () => {
    setLoading(true);
    const token = authtoken;
    const data = {
        domain: baseURL, 
    }
    editCustomDomainAPI(token, data).then((res) => {
      setLoading(false)
        if (res?.flag) {
          console.log("Getting user")
          getuserapicall();
          toast.success("Successfully Updated Domain Details. Please verify if domain name was changed");
        }else{
          toast.error(res?.message);
        }
        }).catch((err) => {
        console.log(err);
        toast.error(err?.message);
    });
  };

  const handleSaveBaseURL = () => {
    setLoading(true);
    const token = authtoken;
    const data = {
       domain: baseURL, 
    }
    createCustomDomainAPI(token, data).then((res) => {
        setLoading(false)
        if (res?.flag) {
          console.log("Getting user")
          toast.success("Successfully Created and Saved Domain Details.");
          getuserapicall();
          resetVerifyApiTimer();
        } else{
            toast.error(res?.message);
        }
    }).catch((err) => {
        console.log(err);
        toast.error(err?.message);
    });
  };

   const handleVerifyDomain = () => {
     const token = authtoken;
     setLoading(true);
     verifyCertificateApi(token).then((res) => {
      setLoading(false)
      resetVerifyApiTimer();
      if (res?.flag) {
        toast.success("Successfully Verified Domain Details.");
        getuserapicall();
        resetTestConnectionApiTimer();
      } else{
          toast.error(res?.message);
      }
    }).catch((err) => {
        console.log(err);
        toast.error(err?.message);
    });
  };

  return loading ? (
    <div
      className="d-flex flex-column justify-content-center align-items-center w-100"
      style={{ flex: 1 }}
    >
      <SpinnerLoader />
    </div>
  ) : (
    <div className="domain-container">
      <h2 className="domain-title">Domain settings</h2>
      <p className="domain-subtitle">
        Add custom domain for WhatsApp Message links (Visit Website)
      </p>
  
      <div className="domain-card">
        {/* Step 1 */}
        <div className="domain-section">
          <h3 className="domain-subheading">1. Setup Base URL</h3>
          <p className="domain-subtext">You can access your base url from your DSP</p>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 0px' }}>
            <input
              type="text"
              placeholder="Paste here"
              value={baseURL}
              disabled={isEditingBaseURL}
              onChange={(e) => setBaseURL(e.target.value)}
              className="domain-input"
            />
            {!isEditingBaseURL ? (
              <CheerioButton
                btnText="Save"
                onclick={handleSaveBaseURL}
                backColor={colors.primary03}
                borderStyle={{ border: 'none', height: 34 }}
                textStyle={{ color: colors.white, fontWeight: 600, fontSize: 13 }}
              />
            ) : (
              // <CheerioButton
              //   btnText="Edit"
              //   onclick={handleEditBaseURL}
              //   backColor={colors.primary03}
              //   borderStyle={{ border: 'none', height: 34 }}
              //   textStyle={{ color: colors.white, fontWeight: 600, fontSize: 13 }}
              // />
              null
            )}
            {isEditingBaseURL ? (
            localdata?.domainDetails?.isVerified ? (
              <div
                style={{
                  backgroundColor: "#e6f7ec",
                  color: "#2e7d32",
                  padding: "6px 12px",
                  borderRadius: "6px",
                  fontWeight: 600,
                  fontSize: 13,
                  height: 34,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                ✅ DNS Connection Verified
              </div>
            ) : (
              <>
                <CheerioButton
                  btnText="Verify Domain"
                  onclick={handleVerifyDomain}
                  backColor={colors.primary03}
                  disabled={verifyDomainApiTimer != 0}
                  borderStyle={{ border: 'none', height: 34 }}
                  textStyle={{ color: colors.white, fontWeight: 600, fontSize: 13 }}
                />
                {verifyDomainApiTimer > 0 && (
                  <p style={{ fontSize: 12, color: colors.greys04 }} className="form-label">
                    {`Try in ${verifyDomainApiTimer} seconds`}
                  </p>
                )}
              </>
            )
          ) : null}
          </div>
        </div>
  
        {/* Step 2 */}
        <div className="domain-step">
          <h3 className="domain-step-title">2. Setup DNS Record</h3>
          <p className="domain-step-desc">
            Paste the mentioned record details in your DNS Settings
          </p>
          <table className="dns-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>TTL</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  {localdata?.domainDetails?.cnameName ? (
                    <>
                      <span>{localdata.domainDetails.cnameName}</span>
                      <Tooltip title="Copy Name">
                        <img
                          src={images.Copy}
                          height={18}
                          width={18}
                          style={{ cursor: 'pointer', opacity: 0.7 }}
                          alt="Copy"
                          onClick={() => {
                            navigator.clipboard.writeText(localdata.domainDetails.cnameName);
                            toast.success('Copied to clipboard');
                          }}
                        />
                      </Tooltip>
                    </>
                  ) : (
                    <span>Will be added after you create a domain</span>
                  )}
                </td>
  
                <td>CNAME</td>
                <td>30 Mins</td>
  
                <td style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  {localdata?.domainDetails?.cnameValue ? (
                    <>
                      <span>{localdata.domainDetails.cnameValue}</span>
                      <Tooltip title="Copy Value">
                        <img
                          src={images.Copy}
                          height={18}
                          width={18}
                          style={{ cursor: 'pointer', opacity: 0.7 }}
                          alt="Copy"
                          onClick={() => {
                            navigator.clipboard.writeText(localdata.domainDetails.cnameValue);
                            toast.success('Copied to clipboard');
                          }}
                        />
                      </Tooltip>
                    </>
                  ) : (
                    <span>Will be added after you create a domain</span>
                  )}
                </td>
              </tr>
              <tr>
                <td style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  {localdata?.domainDetails?.domain ? (
                    <>
                      <span>{localdata.domainDetails.domain}</span>
                      <Tooltip title="Copy Name">
                        <img
                          src={images.Copy}
                          height={18}
                          width={18}
                          style={{ cursor: 'pointer', opacity: 0.7 }}
                          alt="Copy"
                          onClick={() => {
                            navigator.clipboard.writeText(localdata.domainDetails.domain);
                            toast.success('Copied to clipboard');
                          }}
                        />
                      </Tooltip>
                    </>
                  ) : (
                    <span>Will be added after you verify your domain</span>
                  )}
                </td>
  
                <td>CNAME</td>
                <td>30 Mins</td>
  
                <td style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  {localdata?.domainDetails?.apiGatewayDomainName ? (
                    <>
                      <span>{localdata.domainDetails.apiGatewayDomainName}</span>
                      <Tooltip title="Copy Value">
                        <img
                          src={images.Copy}
                          height={18}
                          width={18}
                          style={{ cursor: 'pointer', opacity: 0.7 }}
                          alt="Copy"
                          onClick={() => {
                            navigator.clipboard.writeText(localdata.domainDetails.apiGatewayDomainName);
                            toast.success('Copied to clipboard');
                          }}
                        />
                      </Tooltip>
                    </>
                  ) : (
                    <span>Will be added after you verify your domain</span>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
                  
      {!localdata?.domainDetails?.isVerified && (
        <label className="domain-checkbox-container">
          <input
            type="checkbox"
            checked={isChecked}
            onChange={() => setIsChecked(!isChecked)}
          />
          <span>
            I have completed the above mentioned steps and have verified my domain
          </span>
        </label>
      )}
  
      <div className="domain-button-wrapper">
        {localdata?.domainDetails?.isVerified ? (
          <div
            style={{
              backgroundColor: "#e6f7ec",
              color: "#2e7d32",
              padding: "10px 16px",
              borderRadius: "6px",
              fontWeight: 600,
              fontSize: "14px",
              textAlign: "center",
            }}
          >
            ✅ Setup Completed Successfully
          </div>
        ) : (
          <>
            <CheerioButton
              id="test-connection-btn"
              btnText={loading ? "Testing..." : "Test Connection"}
              disabled={
                !isChecked || loading || !localdata?.domainDetails?.acmVerified || testConnectionApiTimer !== 0
              }
              onclick={handleTestConnection}
              backColor={colors.primary03}
              borderStyle={{
                border: "none",
                width: "100%",
                justifyContent: "center",
              }}
              textStyle={{
                color: colors.white,
                fontWeight: 600,
                fontSize: "14px",
              }}
            />
            {testConnectionApiTimer > 0 && (
              <p style={{ fontSize: 12, color: colors.greys04, padding: '10px' }} className="form-label">
                {`Try in ${testConnectionApiTimer} seconds`}
              </p>
            )}
          </>
        )}
      </div>
      <ToastContainer />
    </div>   
  );
}; 

export default DomainDetails